import en from './locales/en.json'

export default { en }
